


import { Component, Ref, Vue } from 'vue-property-decorator';
import OverviewGraphic from '../OverviewGraphic/index.vue';
import SummaryInfo from '../SummaryInfo/index.vue';
import { Summary, Floor } from '@/utils/api';
import { RouteNames } from '@/utils/router/router.models';
import { Layer } from '@/components/LayeringEngine/LayeringEngine.models';
import generateITSMedia from '@/utils/helpers/generateITSMedia';
import getFloorLayers from '@/utils/helpers/getFloorLayers';
import getOutsideLayers from '@/utils/helpers/getOutsideLayers';
import { ResponsiveImageDimensions } from '@/components/utils/ResponsiveImage/ResponsiveImage.models';
import { FloorGraphicWithID } from '../OverviewGraphic/OverviewGraphic.models';
import { namespace } from 'vuex-class';
const summaryModule = namespace('summary');

@Component({
  components: {
    OverviewGraphic,
    SummaryInfo
  }
})
export default class SummaryOverview extends Vue {
  @summaryModule.State private info!: Summary;

  @summaryModule.Getter private groundFloor?: Floor;
  @summaryModule.Getter private upperFloor?: Floor;
  @summaryModule.Getter private attic?: Floor;
  @summaryModule.Getter private atticEnabled?: boolean;

  private RouteNames: typeof RouteNames = RouteNames;

  public showOverscroll = false;
  public scrollEndReached = false;
  private resizeHandler: () => void = () => {
    return;
  };
  private scrollHandler: () => void = () => {
    return;
  };

  @Ref('infoContent') public infoContentElement!: HTMLDivElement;

  // TODO: check correct image dimensions
  private overviewMediaDimenstions: ResponsiveImageDimensions = {
    MQ1: [480, 480],
    MQ2: [768, 768],
    MQ3: [1024, 576],
    MQ4: [1280, 720],
    MQ5: [1440, 810],
    MQ6: [1920, 1080]
  };

  // TODO: check correct image dimensions
  private floorMediaDimenstions: ResponsiveImageDimensions = {
    MQ1: [480, 480],
    MQ2: [768, 768],
    MQ3: [164, 84],
    MQ4: [200, 102],
    MQ5: [240, 123],
    MQ6: [285, 147]
  };

  private get overview(): Layer[] {
    return getOutsideLayers(this.info.configuration, this.overviewMediaDimenstions);
  }

  /**
   * returns the graphics information needed to render thumbnail-sized
   * previews of the floors' configurations
   */
  private get floors(): FloorGraphicWithID[] {
    const floors = [this.upperFloor, this.groundFloor];

    if (this.atticEnabled) {
      floors.unshift(this.attic);
    }

    return floors
      .filter((floor: Floor | undefined): floor is Floor => !!floor)
      .map(floor => ({
        base: floor.image
          ? {
              ID: floor.ID,
              alt: floor.name,
              media: generateITSMedia(floor.image, this.floorMediaDimenstions)
            }
          : undefined,
        name: floor.name,
        layers: getFloorLayers(floor, this.floorMediaDimenstions),
        floorID: floor.ID
      }));
  }

  public scroll() {
    this.infoContentElement.scrollTop = this.scrollEndReached
      ? 0
      : this.infoContentElement.scrollHeight - this.infoContentElement.offsetHeight;
  }

  public mounted() {
    this.checkIfOverscrollIsNeeded();
    this.checkForScrollEnd();

    this.scrollHandler = () => this.checkForScrollEnd();
    this.infoContentElement.addEventListener('scroll', this.scrollHandler);

    this.resizeHandler = () => this.checkIfOverscrollIsNeeded();

    window.addEventListener('resize', this.resizeHandler);
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
    if (this.infoContentElement) {
      this.infoContentElement.removeEventListener('scroll', this.scrollHandler);
    }
  }

  private checkIfOverscrollIsNeeded() {
    this.showOverscroll = this.infoContentElement.scrollHeight > this.infoContentElement.offsetHeight;
  }

  private checkForScrollEnd() {
    this.scrollEndReached =
      this.infoContentElement.offsetHeight + this.infoContentElement.scrollTop === this.infoContentElement.scrollHeight;
  }
}
